import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';
import { determineUnread } from '../function/determine-unread.function';
import { filterIsDefault } from '../function/filter-is-default.function';
import { filterItems } from '../function/filter-items.function';
import { FilterOptions } from '../model/filter-options.model';
import { itemTransformer } from '../transformer/item.transformer';

import { FilterItems, FilterItemsResult } from './filter-items.action';

export function filterItemsReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType, FilterItems>,
): EventCentreDialogState {
    try {
        /* ignore date range change until resultReducer,
        so that filterItemsEpic can reload items if the date range did change */
        const nextFiltOpts: FilterOptions = {
            ...action.payload.opts,
            dateRange: state.filterOpts.dateRange,
        };

        const nextFilt = filterItems({
            items: state.items,
            categoryId: state.categoryId,
            filterOpts: nextFiltOpts,
            categories: state.categories,
            orderBy: state.orderBy,
        });

        const nextFiltDef = filterIsDefault(nextFiltOpts);

        return {
            ...state,
            filterOpts: nextFiltOpts,
            filterIsDefault: nextFiltDef,
            filteredItems: nextFilt,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}

export function filterItemsResultReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType, FilterItemsResult>,
): EventCentreDialogState {
    try {
        const nextItems = itemTransformer(
            action.payload.items,
            state.categories.slice(1),
        );

        const nextCategories = determineUnread(state.categories, nextItems);
        console.log(nextCategories);

        const nextFilt = filterItems({
            items: nextItems,
            categoryId: state.categoryId,
            filterOpts: action.payload.opts,
            categories: nextCategories,
            orderBy: state.orderBy,
        });

        const nextFiltDef = filterIsDefault(action.payload.opts);

        return {
            ...state,
            categories: nextCategories,
            filterOpts: action.payload.opts,
            filterIsDefault: nextFiltDef,
            items: nextItems,
            filteredItems: nextFilt,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
